import React, { useEffect, useState } from 'react';
import css from '../Forms.module.scss';
import AddImage from 'components/common/AddImage';
import PreviewImage from 'pages/Managment/MyProfile/PreviousProjects/NewImage/PreviewImage';

const TemplateType = ({ handleSetAnswer, isOptionSelected, templates, answer }) => {
  const [image, setImage] = useState(null);
  const [showPreview, setShowPreview] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const handleUpload = (e) => {
    setImage(e.target.files[0]);
    setShowPreview(true);
    handleSetAnswer({ value: 'custom', img: e.target.files[0] }, 'templateCustom');
  };
  const handleDeletePreview = () => {
    setShowPreview(false);
    setImage(null);
    handleSetAnswer(null, 'templateCustom', 'remove');
  };
  const handleSetCommonAnswer = (t) => {
    handleSetAnswer({ ...t, value: t?.img }, 'template');
    setImage(null);
    setShowPreview(false);
  };
  useEffect(() => {
    if (answer?.answers[0]?.value === 'custom') {
      setImage(answer?.answers[0]?.img);
      setShowPreview(true);
      setIsEdit(answer?.answers[0]?.edit);
    }
  }, [answer]);

  return (
    <>
      <div className={css.templates_container}>
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <div style={{ width: 250, height: 250 }}>
            {showPreview ? (
              <>
                {isEdit ? (
                  <PreviewImage
                    myPreview={image}
                    width={250}
                    height={250}
                    onDelete={handleDeletePreview}
                  />
                ) : (
                  <PreviewImage
                    file={image}
                    width={250}
                    height={250}
                    onDelete={handleDeletePreview}
                  />
                )}
              </>
            ) : (
              <label htmlFor="cms-templateimg" style={{ width: '100%', height: '100%' }}>
                <input
                  type="file"
                  accept="image/*"
                  id="cms-templateimg"
                  style={{ display: 'none' }}
                  onChange={handleUpload}
                />
                <AddImage
                  text="Agregar mi propia imagen"
                  style={{ width: 250, height: '100%' }}
                  iconSize={50}
                />
              </label>
            )}
          </div>
        </div>
        {templates?.map((t) => (
          <div key={t.img} className={css.template} onClick={() => handleSetCommonAnswer(t)}>
            <img
              src={t.img}
              alt="template"
              style={
                isOptionSelected({ ...t, value: t.img })
                  ? { border: '2px solid #3383ff', opacity: 1 }
                  : {}
              }
            />
          </div>
        ))}
      </div>
    </>
  );
};

export default TemplateType;
